import React from 'react';

import { WpPageLayout, WpPageHeader, WpPageTitle, WpPageBody } from '../../components/page-layout';
import { TrExamples } from 'Shared/components/i18n/TrExamples';

const HomePage = () => {
  return (
    <WpPageLayout>
      <WpPageHeader sticky>
        <WpPageTitle title="Design System" />
      </WpPageHeader>
      <WpPageBody>
        <>Design System Docs - more coming soon!</>
        <TrExamples />
      </WpPageBody>
    </WpPageLayout>
  );
};

export default HomePage;
